import React,{useState} from "react";
import { EditMaterialUrl } from "../../libs/env";
import { handleMaterialInput } from "../../components/edit_quiz_helper/EditQuizHelper";
import EditButton from "../../components/buttons/EditButton";

const MaterialContent = ({ data,genBox,UpdateMaterial }) => {
  const [Contentedit, setContentedit] = useState(false);
  const [isBlinking, setIsBlinking] = useState(false);
  const focusBlink = (e) => {
    setIsBlinking(false);
  }
  const blurBlink = (e) => {
    if(Contentedit)
    {
      setIsBlinking(true);
    }
  }
  return (
   
    <div className="app">
        { data.output_prompt_content && window.location.pathname.includes(EditMaterialUrl) ? (
            <div style={{float: "right"}}>
              {Contentedit ?
                (<EditButton
                label="Save"
                  onClick={() => {
                    setContentedit(false);
                    UpdateMaterial(data);
                    setIsBlinking(false);
                  }}
                />):
                (
                  <EditButton
                  label="Edit"
                  onClick={() => {
                    setContentedit(true);
                    setIsBlinking(true);
                  }}
              />
                )}
            </div>):null}
        {isBlinking && <span style={{float: "left"}} class="blink-icon"></span>}
        {data.output_prompt_content ? (
            <div
                onFocus={focusBlink}
                onBlur={blurBlink}
                spellcheck="false"
                data-gramm="false"
                contentEditable={Contentedit}
                onInput={handleMaterialInput({
                    type: "htmlcontent",
                    materialdata: data,
                })}
                dangerouslySetInnerHTML={{
                    __html: ` ${data.output_prompt_content} 
                              ${genBox? `<span class="blinking-cursor"></span>`: ""}`,
                }}
            />
        ): genBox && (<span class="blinking-cursor"></span>)}
    </div>
  );
};

export default MaterialContent;
